export default __webpack_public_path__ + "static/media/Inter-UI-SemiBoldItalic.2488c420.woff";